import { useMutation } from '@tanstack/react-query';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { releasePortfolioWorkflowStatus } from './portfolioCardService';

interface PortfolioReleaseWorkflowParams {
  portfolioId: string;
}

export const usePortfolioReleaseWorkflowState = () => {
  const authContext = useAuthenticationContext();

  return useMutation<boolean, Error, PortfolioReleaseWorkflowParams>({
    mutationFn: async ({ portfolioId }) => {
      const response = await releasePortfolioWorkflowStatus(authContext, portfolioId);
      return response;
    }
  });
};
